import { useMutation } from "@apollo/client";
import { REAUTHENTICATE_INTEGRATION_MUTATION } from "../../../apis/salesforce/queries";
import {
  ReauthenticateIntegrationResponse,
  ReauthenticateIntegrationVariables,
} from "../types";
import { HG_FORCE_CLIENT } from "../../../utils/consts";

export interface UseReauthenticateIntegrationOptions {
  onCompleted?: (data: ReauthenticateIntegrationResponse) => void;
  onError?: (error: Error) => void;
  refetchQueries?: string[];
}

export const useReauthenticateIntegration = (
  options: UseReauthenticateIntegrationOptions = {}
) => {
  const { onCompleted, onError, refetchQueries = [] } = options;

  const [reauthenticateIntegrationMutation, result] = useMutation<
    ReauthenticateIntegrationResponse,
    ReauthenticateIntegrationVariables
  >(REAUTHENTICATE_INTEGRATION_MUTATION, {
    context: { clientName: HG_FORCE_CLIENT },
    onCompleted,
    onError,
    refetchQueries,
    errorPolicy: "all",
  });

  const reauthenticateIntegration = async (
    variables: ReauthenticateIntegrationVariables
  ) => {
    try {
      const response = await reauthenticateIntegrationMutation({ variables });
      return response.data?.reauthenticateIntegration;
    } catch (error) {
      console.error("Error reauthenticating integration:", error);
      throw error;
    }
  };

  return {
    reauthenticateIntegration,
    ...result,
    integration: result.data?.reauthenticateIntegration,
  };
};
